var viewer_figure_default = {
  "figure": "_3cTBH"
};
export {
  viewer_figure_default as default
};
//# sourceMappingURL=viewer-figure-scss.js.map
